/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { ICardGroupInsertUpdate } from '../../../models/cardgroup.interface';
import { dropdown, toggleDropDown } from "../../dropdown";
import { handleFilterSectionToggle } from "../common/filter-section-toggle";
import { PAYMENT_TYPE_LIST, FILTER_SECTION } from '../common/filter-elements';
import { filterClear } from "../common/filter-clear";
import { cardGroupDropDown } from '../common/card-group-dropdown';

/**
 * Function that handles the table filter for the card group table.
 * 
 * @param {TabulatorFull} tableObject the table class instance
 * 
 * @returns void
 */
export const cardGroupTableFilter = (tableObject: TabulatorFull) => {
  if ( typeof tableObject != 'object' || tableObject === null || tableObject === undefined ) return;

  const { data: tableData } = tableObject.options as { data: ICardGroupInsertUpdate[] };
  cardGroupDropDown(tableData);
  dropdown(PAYMENT_TYPE_LIST, 'one', 'Payment', false, true, true);

  handleFilterSectionToggle(".aafp_filter-header");

  FILTER_SECTION.searchFilterButton!.addEventListener('click', () => {
    searchCardGroupTable(tableObject);
  });

  FILTER_SECTION.clearFilterButton!.addEventListener('click', () => {
    filterClear('.table-filter-clear');
    tableObject.clearFilter(true);
  });
}

/**
 * Parses the data from the cardList api response and displays it as a table.
 * 
 * @param {TabulatorFull} table the Tabulator table class
 * 
 * @returns void
 */
const searchCardGroupTable = (table: TabulatorFull) => {
  let customer = document.querySelector('#aafp_customer-list-sort') as HTMLInputElement;
  let payment = document.querySelector('#aafp_dropdown-button-one') as HTMLInputElement;
  let group = document.querySelector('#aafp_dropdown-button-two') as HTMLInputElement;
  let filterArr: object[] = [];

  if ( typeof payment.dataset.value !== 'undefined' &&  payment.dataset.value !== '2' ) {
    filterArr.push({field: 'paymentMethod', type: '=', value: payment.dataset.value});
  }

  if (customer.value != '') {
    filterArr.push({field: 'customerName', type: 'like', value: customer.value});
  }

  if(typeof group.dataset.value !== 'undefined' &&  group.dataset.value !== '') {
    filterArr.push({field: 'cardGroupId', type: '=', value: group.dataset.value});
  }

  table.setFilter(filterArr);
}